import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListUsersUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/users/users`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { users } = data; 

      users = users.map((user) => {
        return {
          ...user,
          key: user.id,
          itemLink: Routes.user(user)
        }
      })
      data.list = users;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListUsersUseCase();
export default instance;